import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { ServiceRequest } from 'src/models';
import { UseQueryOverrideOptions } from '../common';

export type UseGetServiceRequestDetailsParams = {
  serviceRequestId: string;
};

export type GetServiceRequestDetailsResponse = ServiceRequest;

export const useGetServiceRequestDetails = (
  params: UseGetServiceRequestDetailsParams,
  options: UseQueryOverrideOptions<GetServiceRequestDetailsResponse> = {}
) => {
  const { serviceRequestId } = params;

  return useQuery({
    ...options,
    queryKey: ['serviceRequest', serviceRequestId],
    queryFn: () =>
      api
        .get<GetServiceRequestDetailsResponse>(
          `/v3/service_request/${serviceRequestId}`
        )
        .then(({ data }) => data),
  });
};
